$(document).ready(function () {
    const scrollToTop = $('.scrollToTop');
    const btnScrollTo = $('#btnScrollTo');

    scrollToTop.on('click', function (event) {
        $('html, body').animate({
            scrollTop: $("body").offset().top
        }, 1000);
    });

    $(window).scroll(function () {
        var wH = $(window).height(),
            wS = $(this).scrollTop();

        if (wS >= wH) {
            btnScrollTo.addClass('show');
        } else {
            btnScrollTo.removeClass('show');
        }
    });


    /**
     * VideoJS
     * show button 2 minutes after video starts
     */
    // if ($('#proPlantVSL').length) {
    //     videojs('proPlantVSL').ready(function () {
    //         this.on('timeupdate', function () {
    //             if (this.currentTime() >= (60 * 1) || this.currentTime() == this.duration()) {
    //                 $('.vslSection .btn').removeClass('invisible');
    //             }
    //             // console.log(this.currentTime());
    //         })
    //     });
    // };

    /**
     * Offer stamp animation
     * gets the data-stamp attr and duplicates it to create the shadow under the animation
     */
    if ($('#offerStamp').length) {
        const thisElement = $('#offerStamp');
        const offerText = thisElement.html();
        thisElement.append('<span class="offer-stamp__text">' + offerText + '</span>')
    }

    /**
     * Scroll to Cart
     */
    if ($('#salesBanner').length) {
        let salesBannerHeight = Math.floor($('#salesBanner').height());

        if ($('#salesBanner').hasClass('isSticky')) {

            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - salesBannerHeight
                }, 1000);
            });
        } else {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            });
        }
    } else {
        $('.btn:not(.cta), #giveAwayBanner').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        });
    }

    /**
     * Open subscribeSection if closed
     */
     $('.giveAwayBanner--bcGifts').on('click', function() {
        if(!$('#subscribeSection').hasClass('active')) {
            $('.subscribe-wrap').toggleClass('active');
        }
    });

    /**
     * Toggle Product Type
     */
    function activateProductType() {
        let thisProduct = $(this);
        let thisProductAttr = thisProduct.attr('data-product-option');

        // storage both elements
        let selectedProductType = $('#cartToggle').find(`[data-product-option='${thisProductAttr}']`);
        let selectedProductWrapper = selectedProductType.parent();

        if (!thisProduct.hasClass('active')) {
            $('.product-switch__option').removeClass('active');
            selectedProductType.addClass('active');
        }

        //- assign the chosen product attr to its parent
        selectedProductWrapper.attr('data-product', thisProductAttr);

        // console.log(selectedProductWrapper.attr('data-product'));

        // check and control images to show based on attr data-product 
        if (selectedProductWrapper.attr('data-product') === 'optional') {
            $('.cart__img-default').removeClass('show').addClass('hide');
            $('.cart__img-optional').removeClass('hide').addClass('show');

        } else {
            $('.cart__img-default').removeClass('hide').addClass('show');
            $('.cart__img-optional').removeClass('show').addClass('hide');
        }

        $('.cart__product.active').trigger("click");
    }

    /**
     * Cart Toggle Section Modes and updates each section 
     */
    function activeProduct() {
        let thisProduct = $(this);
        let chooseProductAttr = $('.product-switch').attr('data-product');

        let amount = thisProduct.attr('data-units'),
            link,
            price = 'data-price',
            ship = 'data-shipping',
            retail = 'data-retail',
            sale = '';

        let selectedProductAmount = $('#cartToggle').find(`[data-units='${amount}']`);

        if (chooseProductAttr === 'optional') {
            link = 'option-link';

        } else {
            link = 'link';
        }

        /**
         * Specific vars for Subscription Mode
         */
        let subscriptionMode = {
            wrap: $('#subscribeSection'),
            prod: $('#subscribeSection').find(`[data-units='${amount}']`),
            param: $('#subscribeSection').find('.btn').attr('data-param')
        }

        /**
         * Specific vars for Normal Mode
         */
        let regularMode = {
            wrap: $('#regularSection'),
            prod: $('#regularSection').find(`[data-units='${amount}']`),
            param: $('#regularSection').find('.btn').attr('data-param')
        }
        /**
         * Under Morning Sale 
         */
        if ($('body').hasClass('show-promoBanner')) {
            sale = '-sale';
        }

        /**
         * Product buttons states
         */
        $('.cart__product').removeClass('active');
        selectedProductAmount.addClass('active');

        /**
         * Controls Product Images based on selection
         */
        $('#orderNow').removeClass(function (index, className) {
            return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
        }).addClass('cart--unit' + amount);

        const carts = [subscriptionMode, regularMode];

        for (const cart of carts) {
            let savingsVal = cart['prod'].attr(retail) - cart['prod'].attr(price + sale);

            cart['wrap'].find('.price__value').html(cart['prod'].attr(price + sale));
            cart['wrap'].find('.retail__value').html('$' + cart['prod'].attr(retail));
            cart['wrap'].find('.saving__value').html('$' + parseFloat(savingsVal).toFixed(2));

            cart['wrap'].find('.shipping__value').html(cart['prod'].attr(ship) + ' SHIPPING');

            cart['wrap'].find('.btn').attr('href', (cart['prod'].attr('data-' + link + sale) + cart['param']));
        }
    };

    /**
     * Subscription Option UI and Behaviour 
     */
    $('.subscribe-wrap__option').on('click', function () {
        $('.subscribe-wrap').toggleClass('active');

        if ($('#cartToggle').attr('data-check') === 'un-subscribe') {
            $('#cartToggle').attr('data-check', 'subscribe');

        } else {
            $('#cartToggle').attr('data-check', 'un-subscribe');

        }

        //- reset subscription disclaimer checkbox
        if ($('#disclaimerTrigger').hasClass('checked') && !$('#cartCTASubscribe').hasClass('disabled')) {
            $('#disclaimerTrigger').removeClass('checked');
            $('#cartCTASubscribe').addClass('disabled');
            $('.purchase-box__checkbox').attr('data-checkbox', false);
        }

        if ($('body').hasClass('show-promoBanner')) {
            let promoBannerHeight = Math.floor($('#promoBanner').height());

            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - promoBannerHeight
            }, 1000);

        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        }
    })

    /**
     * Disclaimer Checkbox and Button disabled
     */
    $('#disclaimerTrigger').on('click', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('checked') && $('#cartCTASubscribe').hasClass('disabled')) {
            $(this).addClass('checked');
            $('#cartCTASubscribe').removeClass('disabled');
            $('.purchase-box__checkbox').attr('data-checkbox', true);
            //handle alert
            $(".purchase-box__alert").removeClass('show');
            $(".purchase-box__checkmark").removeClass('alert');

        } else {
            $(this).removeClass('checked');
            $('#cartCTASubscribe').addClass('disabled');
            $('.purchase-box__checkbox').attr('data-checkbox', false);
        }
    });

    //Add alert 
    $('.wrapCTA').on('click', function () {
        if($('#cartCTASubscribe').hasClass('disabled')){
            $(".purchase-box__alert").addClass('show');
            $(".purchase-box__checkmark").addClass('alert');
        }
    })

    $('.product-switch__option').on('click', activateProductType);

    $('.cart__product').on('click', activeProduct);
    $('.cart__product.active').trigger("click");

    /**
     * Reviews Slick
     */
    $('#reviewsList').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false
    });

    /**
     * Handle Video instances Play/Pause
     */
    // Create array for player IDs
    let players = [];

    // Determine the available player IDs
    for (let i = 0; i < Object.keys(videojs.players).length; i++) {
        // Assign the player name to setPlayer
        var setPlayer = Object.keys(videojs.players)[i];

        // Define the ready event for the player
        videojs.getPlayer(setPlayer).ready(function () {
            // Assign this player to a variable
            let myPlayer = this;

            //- Assign Slick controls to a variable
            let slickArrow = $('.slick-arrow');
            let slickDots = $('.slick-dots li');

            // Assign and event listener for play event
            myPlayer.on("play", onPlay);

            slickArrow.on("click", onPlay);
            slickDots.on("click", onPlay);

            // Push the player to the players array
            players.push(myPlayer);
        });
    }

    // Handle all players' play event 
    function onPlay(e) {
        // Determine which player the event is coming from
        var id = e.target.id;

        // Loop through the array of players
        for (let x = 0; x < players.length; x++) {
            // Get the player(s) that did not trigger the play event
            if (players[x].id() != id) {
                // Pause the other player(s)
                videojs(players[x].id()).pause();
            }
        }
    }

    /**
     * product Images Carousel Slick
     */
    if ($('.style1 #productImagesCarousel').length) {
        $('#productImagesCarousel').slick({
            slidesToShow: 1,
            arrows: true,
            dots: true,
            speed: 700,
            adaptiveHeight: false,
            centerMode: false,
            infinite: true
        });
    }
    if ($('.style2 #productImagesCarousel').length) {
        $('#productImagesCarousel').slick({
            slidesToShow: 1,
            arrows: false,
            dots: false,
            speed: 700,
            autoplay: true,
            autoplaySpeed: 4000,
            adaptiveHeight: false,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: true
                    }
                }
            ]
        });
    }

    if ($('.style3 #productImagesCarousel').length) {
        $('#productImagesCarousel').slick({
            slidesToShow: 1,
            arrows: false,
            dots: false,
            speed: 700,
            adaptiveHeight: false,
            centerMode: false,
            asNavFor: '#productImagesNav',
            infinite: true
        });
    }

    if ($('#productImagesNav').length) {
        $('#productImagesNav').slick({
            slidesToShow: 3.5,
            slidesToScroll: 1,
            asNavFor: '#productImagesCarousel',
            focusOnSelect: true,
            arrows: false,
            mobileFirst: true,
            infinite: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 4.5
                }
              }
            ]
        });
    }

    // Play - Pause btn
    $('.pauseBtns .pause').on('click', function () {
        $('.pauseBtns .pause').removeClass('show').addClass('hide');
        $('.pauseBtns .play').removeClass('hide').addClass('show');
        $('.style2 #productImagesCarousel')
            .slick('slickPause')
    });

    $('.pauseBtns .play').on('click', function () {
        $('.pauseBtns .play').removeClass('show').addClass('hide');
        $('.pauseBtns .pause').removeClass('hide').addClass('show');
        $('.style2 #productImagesCarousel')
            .slick('slickPlay')
    });


    //- handle Modal > load / show correct image
    $('#imageModal').on('show.bs.modal', function (event) {
        let eventTrigger = $(event.relatedTarget); // Button that triggered the modal
        let mediaSrc = eventTrigger.attr('src'); // Extract img src
        let mediaAlt = eventTrigger.attr('alt'); // Extract info from data-* attributes

        let modal = $(this)

        $('body').addClass('productImagesCarousel');
        modal.find('.modal-body img').attr("src", mediaSrc).attr("alt", mediaAlt);
    });

    $('#imageModal').on('hidden.bs.modal', function (event) {
        $('body').removeClass('productImagesCarousel');
    });

    /**
     * Product Benefits bullets
     */

    let num = 0;
    function timeoutDotsAnimation() {
        setTimeout(function () {
            const el = $('#benefitsListAnimated .healthBenefits__item');
            // console.log('num', num);
            (num === 5) ? num = 1 : num++;

            el.removeClass('healthBenefits__item--anim');
            $('#benefitsListAnimated .healthBenefits__item[data-num=' + num + ']').addClass('healthBenefits__item--anim');
            timeoutDotsAnimation();
        }, 3000);
    }

    if ($('#benefitsListAnimated').length) {
        timeoutDotsAnimation();
    }

    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
